import { getPeople as _getPeople } from '@CommonNetwork/people'
import config from 'src/config'
import { loadJWT } from 'src/services/local.storage'

export const getPeople = (user_id?: string, query?: string, limit?: number, offset?: number, only_favourites?: boolean, order_by?: string, order_mode?: string) => {
	return _getPeople(config.api_url, loadJWT(), user_id, query, limit, offset, only_favourites, order_by, order_mode)
}